export default "__VITE_ASSET__Co401sFd__"